import Vue from "vue";
import App from "./App.vue";
import * as VueGoogleMaps from "vue2-google-maps";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faLayerGroup,
  faMapMarkerAlt,
  faClock,
  faUserEdit,
  faTasks,
  faExclamationTriangle,
  faQuestion,
  faCheck,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

library.add(
  faLayerGroup,
  faMapMarkerAlt,
  faClock,
  faUserEdit,
  faTasks,
  faExclamationTriangle,
  faQuestion,
  faCheck,
  faInfoCircle
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("v-select", vSelect);
Vue.config.productionTip = false;
const id = document.getElementById("app").dataset.mapId;
Vue.use(VueGoogleMaps, {
  load: {
    key: atob(id)
      .split("")
      .reverse()
      .join(""),
    libraries: "places,geometry",
    region: "FI",
    language: "fi",
  },
});

new Vue({
  render: (h) => h(App),
}).$mount("#app");
